// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
export default {
    blackButtonLink: {
        href: "/sales/contact-us",
        target: "_self"
    },
    blackButtonText: "Contact Sales",
    title: "The AI work platform your team will love to use",
    whiteButtonText: "Get Started"
};
